package uz.ferro.erp.feature.task.model.dto

import kotlinx.serialization.Serializable

@Serializable
data class TaskFilterDto(
    val assignedTo: Long? = null,
    val customerId: String? = null,
    val dateFrom: String? = null,
    val dateTo: String? = null
)